import { Link } from "gatsby"
// import PropTypes from "prop-types"
import React from "react"

import LogoCovid from "./logo-covid"

const Title = () => {
  return (
    <h1 style={{ margin: 0 }}>
      <Link
        to="/"
        style={{
          color: `white`,
          textDecoration: `none`,
          display: `flex`,
          alignItems: `center`,
        }}
      >
        <LogoCovid />
        <div className="title">
          Fablabs <span className="vs">vs</span>{" "}
          <span className="covid">Coronavirus</span>
        </div>
      </Link>
    </h1>
  )
}

const Header = ({ siteTitle, showTwitter }) => (
  // FIXME
  // on utilise plus le siteTitle venant de propTypes/GraphQL mais un component Title à part
  <header
    style={{
      background: `#8F305B`,
      // backgroundImage: `linear-gradient(to right top, #8f305b, #b1435c, #cd5c5a, #e47956, #f49954)`,
      backgroundImage: `linear-gradient(to right top, #8f305b, #a63c5c, #bb4b5b, #ce5c59, #de6f57)`,
      marginBottom: `1.45rem`,
    }}
  >
    <div
      style={{
        display: "flex",
        justifyContent: `space-between`,
        alignItems: `center`,
        margin: `0 auto`,
        maxWidth: 960,
        padding: `1.45rem 1.0875rem`,
      }}
      className="wrapper"
    >
      <Title />
      {showTwitter && <div className="menu">
        {/* <Link
          to="/"
          style={{
            alignItems: `center`,
          }}
          activeClassName="active"
          >
          Presse
        </Link> */}
        {/* {" | "}
        <Link
          to="/infos/"
          style={{
            alignItems: `center`,
          }}
          activeClassName="active"
        >
          Infos
        </Link> */}
        {/* <Link
          to="/twitter/"
          style={{
            alignItems: `center`,
          }}
          activeClassName="active"
        >
          Twitter
        </Link> */}
      </div>}
    </div>
  </header>
)

// Header.propTypes = {
//   siteTitle: PropTypes.string,
// }

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
